import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "audio-player__footer" }

import DetailedAudioPlayer from "@/components/UI/AudioPlayer/DetailedAudioPlayer.vue";

import SplitPopup from "@/components/UI/Pupup/SplitPopup.vue";
import {computed, onMounted, onUnmounted} from "vue";
import BackgroundAudio, {PlayerMetadata} from "@/ts/Audio/BackgroundAudio";
import CDN from "@/ts/Utility/CDN";
import AudioRepository from "@/ts/Audio/Repository/AudioRepository";
import ImageZoomButton from "@/components/UI/Button/ImageZoomButton.vue";
import ImageViewer from "@/ts/ImageViewer/ImageViewer";


export default /*@__PURE__*/_defineComponent({
  __name: 'AudioPlayerPopup',
  props: {
    image: {},
    title: {},
    audio: {},
    type: {},
    id: {}
  },
  setup(__props: any) {


const props = __props;
const backgroundAudio = BackgroundAudio.getInstance();
const {isPlaying} = backgroundAudio;
const iconName = computed(() => isPlaying.value ? 'pause' : 'play');


const onClick = () => {
  isPlaying.value ? backgroundAudio.pause() : backgroundAudio.play();
}
const onEnded = async () => {
  backgroundAudio.pause()
  const isMeditationListened = backgroundAudio.playerMetadata.value?.type === 'meditations';
  if(isMeditationListened) {
    await AudioRepository.saveMeditationListenedEvent(backgroundAudio.playerMetadata.value?.id!);
  }
}
const onCloseButtonClick = () => {
  backgroundAudio.stop();
}
onMounted(() => {
  backgroundAudio.addEventListener('ended', onEnded);
});
onUnmounted(() => {
  backgroundAudio.removeEventListener('ended', onEnded);
});
const onImageClick = () => {
  ImageViewer.getInstance().show(CDN.createUrl(props.image))
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SplitPopup, {
    "fixed-content-size": "",
    onCloseButtonClick: onCloseButtonClick,
    closeTheme: "dark"
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(DetailedAudioPlayer, {
          image: _ctx.image,
          title: _ctx.title,
          audio: _ctx.audio
        }, null, 8, ["image", "title", "audio"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "audio-player__cover",
        onClick: onImageClick
      }, [
        _createElementVNode("img", {
          src: _unref(CDN).createUrl(_ctx.image),
          alt: "cover"
        }, null, 8, _hoisted_1),
        _createVNode(ImageZoomButton, {
          class: "audio-player__action__zoom",
          theme: "dark"
        })
      ])
    ]),
    _: 1
  }))
}
}

})